import React from 'react';
import './Slider.scss';

const Slider=(props)=>{
    return(
        <div  className={`slider-l-container ${props.styles}`}>
            <p>Trusted by more than 100,000 organizations</p>
        <div className="logo-slider">
            <div className="slide-track">
                {props.list.map((logo) =>{
                    return(
                        <div className="slide">
                            <img src={logo} />
                        </div>
                    )
                })}
            </div>
        </div>
        </div>
    )
};
export default Slider;